module.exports = __webpack_public_path__ + "img/logo-green.b053d0cf.png";